import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../../notifications.service';
import { INotification } from '../../notifications.types';

@Component({
	selector: 'app-notifications-badge',
	styleUrls: ['../../notifications.scss'],
	template: `
		<button
			[mat-menu-trigger-for]="notificationsMenu"
			(click)="notificationsDisplayed()"
			mat-icon-button
			class="ml-xs"
			title="Alerts & Notifications"
		>
			<mat-icon [matBadge]="unreadCount">inbox</mat-icon>
		</button>
		<mat-menu #notificationsMenu class="test-class-applied">
			<div class="notifications">
				<div class="notifications-header" fxLayout="row" fxLayoutAlign="space-between">
					<div>Alerts & Notifications</div>
					<div class="mark-read-link" *ngIf="unreadCount">
						<a (click)="markAllRead()">mark read</a>
					</div>
				</div>
				<div *ngIf="!notifications || notifications.length === 0" class="no-unread">
					No unread notifications to display. Click "view all" to see past notifications.
				</div>
				<div *ngFor="let msg of notifications" class="notification-row">
					<div class="info-row" fxLayout="row" fxLayoutAlign="space-between">
						<div class="type text-left">{{ getTypeDisplayName(msg.type) }}</div>
						<div class="date text-right">{{ msg.lastOccurrenceDate | date: 'MM/dd/yyyy' }}</div>
					</div>
					<div class="message">{{ msg.message }}</div>
					<div class="stats-block" fxLayout="row" fxLayoutAlign="end">
						{{ getOccurrenceText(msg.occurrenceCount) }}
					</div>
				</div>
				<div fxLayout="row" fxLayoutAlign="end" class="view-link">
					<a routerLink="/pilotpay/notifications">View All</a>
				</div>
			</div>
		</mat-menu>
	`
})
export class NotificationsBadgeComponent implements OnInit {
	constructor(private notificationsService: NotificationsService) {
		notificationsService.getNotificationsCount().subscribe(c => this.setUnreadCount(c));
		notificationsService.getPagedNotifications(0, 10, true, '').subscribe((notifications: INotification[]) => {
			this.notifications = notifications;
		});
	}

	public unreadCount: number;
	public notifications: INotification[];

	ngOnInit(): void {}

	getTypeDisplayName(type: number): string {
		if (type === 0) {
			return 'CMS import';
		}

		if (type === 1) {
			return 'Jet Link import';
		}

		return 'Other';
	}

	getOccurrenceText(occurrenceCount: number): string {
		let times: string = 'time';
		if (occurrenceCount !== 1) {
			times = 'times';
		}

		return `issue seen ${occurrenceCount} ${times}`;
	}

	notificationsDisplayed(): void {
		if (this.notifications && this.notifications.length > 0) {
			const notificationIds: number[] = this.notifications.map(p => p.notificationId);
			this.notificationsService.markNotificationsRead(notificationIds).subscribe(c => this.setUnreadCount(c));
		}
	}

	markAllRead(): void {
		this.notificationsService.markAllNotificationsRead().subscribe(c => this.setUnreadCount(c));
	}

	private setUnreadCount(count: number): void {
		if (count === 0) {
			this.unreadCount = null; // hides the badge
			this.notifications = null;
		} else {
			this.unreadCount = count;
		}
	}
}
